import { createRequire as i } from "module";
const n = i(import.meta.url), s = n("isolated-vm"), c = (o) => {
  const t = {};
  for (const [r, e] of Object.entries(o))
    typeof e == "object" && e !== null && !Array.isArray(e) ? t[r] = c(e) : typeof e == "function" ? t[r] = new s.Reference(e) : t[r] = e;
  return t;
};
export {
  c as g
};
